/** Map + table row share this minimum height; grid fills most of the paper column. */
export const COMPS_ROW_MIN_HEIGHT_PX = 520;
export const COMPS_MAP_HEIGHT_PX = COMPS_ROW_MIN_HEIGHT_PX;
export const COMPS_GRID_MIN_HEIGHT_PX = 460;
